import React from 'react';
import { IconSolidPhone } from './Icons';

interface PhoneLabelProps {
  phoneNumber?: number | null;
}

function splitToGroups(str: string): string[] {
  if (str.length !== 9) {
    return [str];
  }
  return [str.slice(0, 3), str.slice(3, 6), str.slice(6)];
}

/**
 * Render phone number as well formatted number, e.g. 777 555 666 (spaces are done by margins, so copied text is whole
 * number)
 *
 * @param param0
 * @param param0.phoneNumber
 * @constructor
 */
export default function PhoneLabel({ phoneNumber }: PhoneLabelProps) {
  if (!phoneNumber) {
    return null;
  }

  const str = String(phoneNumber);
  const parts = splitToGroups(str);

  return (
    <a href={`tel:${str}`}>
      <IconSolidPhone className="mr-2" />
      {parts.map((part, i) => (
        <span key={i} style={{ marginRight: i < parts.length - 1 ? '0.3em' : undefined }}>
          {part}
        </span>
      ))}
    </a>
  );
}
